<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row">
        <label :for="safeId('title')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>
      <clock-control :template-id="templateId"></clock-control>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
        <number-input-group v-model="autoHideSecs" label="Autohide (secs)"></number-input-group>
        <div class="form-group form-row">
          <label class="col-sm-4 col-form-label">Start time</label>
          <div class="col-sm-8">
            <div class="form-group">
              <div class="form-row align-items-end">
                <div class="col">
                  <label :for="safeId('startHours')" class="col-form-label">Hours</label>
                  <input type="number" :id="safeId('startHours')" class="form-control"
                         v-model.number="startHours" min="0" max="99">
                </div>
                <div class="col">
                  <label :for="safeId('startMins')" class="col-form-label">Mins</label>
                  <input type="number" :id="safeId('startMins')" class="form-control"
                         v-model.number="startMins" min="0" max="59">
                </div>
                <div class="col">
                  <label :for="safeId('startSecs')" class="col-form-label">Secs</label>
                  <input type="number" :id="safeId('startSecs')" class="form-control"
                         v-model.number="startSecs" min="0" max="59">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-sm-4 col-form-label">End time</label>
          <div class="col-sm-8">
            <div class="form-group">
              <div class="form-row align-items-end">
                <div class="col">
                  <label :for="safeId('endHours')" class="col-form-label">Hours</label>
                  <input type="number" :id="safeId('endHours')" class="form-control"
                         v-model.number="endHours" min="0" max="99">
                </div>
                <div class="col">
                  <label :for="safeId('endMins')" class="col-form-label">Mins</label>
                  <input type="number" :id="safeId('endMins')" class="form-control"
                         v-model.number="endMins" min="0" max="59">
                </div>
                <div class="col">
                  <label :for="safeId('endSecs')" class="col-form-label">Secs</label>
                  <input type="number" :id="safeId('endSecs')" class="form-control"
                         v-model.number="endSecs" min="0" max="59">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group form-row">
          <label class="col-sm-4 col-form-label">Format</label>
          <div class="col-sm-8">
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="displayHours">Hrs
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="displayMinutes">Mins
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="displayTenths">1/10
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="displayHundredths">1/100
              </label>
            </div>
          </div>
        </div>
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapOverlayOptions, mapTemplateOptions } from '../../utils/index'
  import clockControl from './clock-control'

  export default {
    name: 'generic-clock',
    mixins: [templateMixin],
    components: {clockControl},
    computed: {
      ...mapOverlayData(['title', 'direction']),
      ...mapOverlayOptions(['displayHours', 'displayMinutes', 'displayTenths', 'displayHundredths']),
      ...mapOverlayOptions({'autoHideSecs': {default: 0}}),
      ...mapTemplateOptions({'startTimeMs': {default: 0}, 'endTimeMs': {default: 0}}),
      startHours: {
        get () {
          return Math.floor(this.startTimeMs / 1000 / 3600)
        },
        set (val) {
          this.setStartTimeMs(val, this.startMins, this.startSecs)
        }
      },
      startMins: {
        get () {
          return Math.floor(this.startTimeMs / 1000 / 60 % 60)
        },
        set (val) {
          this.setStartTimeMs(this.startHours, val, this.startSecs)
        }
      },
      startSecs: {
        get () {
          return this.startTimeMs / 1000 % 60
        },
        set (val) {
          this.setStartTimeMs(this.startHours, this.startMins, val)
        }
      },
      endHours: {
        get () {
          return Math.floor(this.endTimeMs / 1000 / 3600)
        },
        set (val) {
          this.setEndTimeMs(val, this.endMins, this.endSecs)
        }
      },
      endMins: {
        get () {
          return Math.floor(this.endTimeMs / 1000 / 60 % 60)
        },
        set (val) {
          this.setEndTimeMs(this.endHours, val, this.endSecs)
        }
      },
      endSecs: {
        get () {
          return this.endTimeMs / 1000 % 60
        },
        set (val) {
          this.setEndTimeMs(this.endHours, this.endMins, val)
        }
      }
    },
    methods: {
      setStartTimeMs (hours, mins, secs) {
        this.startTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1)
        this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down'
      },
      setEndTimeMs (hours, mins, secs) {
        this.endTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1)
        this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/generic-clock.vue